import React, { useEffect, useState } from 'react';
import { db } from "../firebaseConfig";
import {
  collection,
  getDocs
} from "firebase/firestore";
import {
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  IconButton,
  Switch,
  Tooltip,
  CircularProgress
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';

const ListaSolicitudes = ({ handleEditar, handleEliminar, handleToggleStatus, handleDescargarArchivo }) => {
  const [empresas, setEmpresas] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [tipoServiciosList, setTipoServiciosList] = useState([]);
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);  // Estado de carga

  useEffect(() => {
    const fetchData = async () => {
      try {
        const empresasSnap = await getDocs(collection(db, "empresas"));
        const tiposSnap = await getDocs(collection(db, "tipoServicios"));
        const unidadesSnap = await getDocs(collection(db, "unidades"));
        const solicitudesSnap = await getDocs(collection(db, "solicitudservicios"));
  
        const empresasData = empresasSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const tiposData = tiposSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const unidadesData = unidadesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const solicitudesData = solicitudesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  
        console.log("Empresas: ", empresasData);
        console.log("Tipos de Servicios: ", tiposData);
        console.log("Unidades: ", unidadesData);
        console.log("Solicitudes: ", solicitudesData);
  
        setEmpresas(empresasData);
        setTipoServiciosList(tiposData);
        setUnidades(unidadesData);
        setSolicitudes(solicitudesData);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <Box mt={3} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box mt={3}>
      <Typography variant="h6">Solicitudes Guardadas</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Folio</TableCell>
              <TableCell>Unidad</TableCell>
              <TableCell>Empresa</TableCell>
              <TableCell>Tipo de Servicio</TableCell>
              <TableCell>Fecha de Creación</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Archivo</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {solicitudes.map((solicitud) => {
              const unidad = unidades.find((u) => u.id === solicitud.unidadId);
              const empresa = empresas.find((e) => e.id === solicitud.empresaId);
              const tipoServicio = tipoServiciosList.find((t) => t.id === solicitud.tipoServicioId);
              const tieneArchivo = !!solicitud.archivoBase64;

              return (
                <TableRow key={solicitud.id}>
                  <TableCell>{solicitud.folio}</TableCell>
                  <TableCell>{unidad?.numero || unidad?.placa || 'No encontrada'}</TableCell>
                  <TableCell>{empresa?.nombre || 'No disponible'}</TableCell>
                  <TableCell>{tipoServicio?.nombre || 'No disponible'}</TableCell>
                  <TableCell>
                    {solicitud.createdAt?.seconds
                      ? new Date(solicitud.createdAt.seconds * 1000).toLocaleString()
                      : 'Fecha no disponible'}
                  </TableCell>
                  <TableCell>
                    <Switch
                      checked={solicitud.status === 'activo'}
                      onChange={() => handleToggleStatus?.(solicitud.id, solicitud.status)}
                      color="primary"
                    />
                  </TableCell>
                  <TableCell>
                    {tieneArchivo && (
                      <Tooltip title="Descargar archivo">
                        <IconButton onClick={() => handleDescargarArchivo?.(solicitud.archivoBase64, solicitud.folio)}>
                          <DownloadIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                  <TableCell>
                    <Tooltip title="Editar">
                      <IconButton onClick={() => handleEditar?.(solicitud)}>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                      <IconButton onClick={() => handleEliminar?.(solicitud.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ListaSolicitudes;
